// extracted by mini-css-extract-plugin
export default {"card":"project-item_card__u2kql","label":"project-item_label__-UdAb","icon":"project-item_icon__yLclb"};